import React from "react";
const AccountAlreadyVerified = () => {
  return (
    <div className="template-wrapper">
      <h2 className="template-heading">Account Already Verified</h2>
      <p className="template-description">
        Your account has already been activated.
      </p>
      <p
        className="login-btn"
        onClick={() => {
          window.location.href = "/login";
        }}
      >
        Login Now
      </p>
    </div>
  );
};

export default AccountAlreadyVerified;
